import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import DriveEtaIcon from '@material-ui/icons/DriveEta';

import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomToolbar from "../../common/AddButton";
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
  //import { Store } from "../../flux";
import  api from '../../common/api';

class Brands extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        brands:[]
      }
      this.handleDelete = this.handleDelete.bind(this)
      this.handleDialogClose = this.handleDialogClose.bind(this)
    }

    async componentDidMount() {
      await this.getVehicles();
    }
   
   getVehicles(){
     const token =localStorage.getItem('userToken')

     return axios
              .get(api.brands().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, brands: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, brands: [] })
              })
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      

  handleDialogClose(e){
    e.preventDefault();
    this.setState({dialogOpen: false, errors: false, message: '', delete_id: ''})
  }

  handleDelete(e, id){
    e.preventDefault();
    var brand = ''
    this.state.brands.map((val, idx)=>{
        if(val.id === id){
          brand = val.name
          this.setState({delete_id: val.id})
        }
    })

    var message = ''
    if (brand !==''){
        message = 'Está a punto de dar de baja la marca '+ brand +'. ¿Está seguro?'
    } else {
        message = 'Hubo un problema al dar de baja al vehiculo.'
    }
    this.setState({message: message, dialogOpen: true })
  }

  confirmDelete() {
    const token = localStorage.getItem('userToken')
    return axios.delete(api.brands().delete(this.state.delete_id),{ headers: {"Authorization" : `Bearer ${token}`}, params: {'id':this.state.delete_id }}).then(res => {
          this.setState({message: 'Marca dada de baja con éxito!'})
          this.setState({errors: false})
          this.setState({delete_id: '', rowId:''})
      })
      .catch(err =>{
          this.setState({errors: true})
          this.setState({delete_id: '', rowId:''})
          this.setState({message: err.response.data.errors["id"]})
      })

  }

  handleRefresh(e){
    e.preventDefault();
    window.location.href=`/brands`
  }

  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "name",
      label: "Nombre",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },{
        name: "Acciones",
        label: "",
        options: {
            filter: false,
            setCellHeaderProps: () => ({ align: 'right' }),
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[0]
              //const rowId = 1
              return (
                <div className="row" style={{display: 'block', textAlign: 'right', paddingRight: '30px'}}>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"models/"+rowId} >
                    <DriveEtaIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"brand/"+rowId} >
                    <EditIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="secondary" aria-label="edit" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"brand/"+rowId+"/1"}>
                    <ViewIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  onClick={(e)=>{this.handleDelete(e, rowId)}}>
                    <DeleteIcon fontSize="small" /> 
                  </Fab>
                </div>
                  )}
            }
     }
    ];


  const options = {
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    selectableRows: false,
    rowsPerPage: 10,
      customToolbar: () => {
        return (
          <CustomToolbar url="new" />
        );
      },
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
               <Dialog
                  open={this.state.dialogOpen}
                  onClose={(e)=>this.handleDialogClose(e)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {(!this.state.errors)?(
                    (this.state.rowId ==='')?
                      <div>
                        <Button onClick={(e)=> {this.handleRefresh(e)}} color="primary" >
                          Continuar
                        </Button>
                      </div>
                    :
                    <div>
                    <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" autoFocus>
                      Cancelar
                    </Button>
                    <Button onClick={this.confirmDelete.bind(this)} color="primary" >
                      Continuar
                    </Button>
                    </div>
                   )
                  :(
                  <div>
                  <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" >
                    Continuar
                  </Button>
                  </div>
                  )}
                </DialogActions>
              </Dialog> 
              </div>            
              <div>
             <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Marcas"
                  data={Object.values(this.state.brands)}
                  columns={columns}
                  options={options}
                 />
                 <div style={{textAlign: "right"}}>
                   <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                      Volver
                  </Button>
                </div>
              </MuiThemeProvider>
              </div>
            </Col>
          </Row>
         </Container>
    );
  }

}

export default Brands;   